import { RadPromiseLike } from "../../../Extensions";
import { ObjectHelper } from "../../../Helpers/ObjectHelper";
import { WebApiClientService } from "../../../Server/WebApiClientService";
import { ServiceManager } from "../../../ServiceManager";
import { NAMESPACE } from "./_Namespace";

export interface ISoftDeleteEnabledListMixin
{
    _getSoftDeletedListItemAsync(info: { listData: any[], primaryEntity: string, primaryEntityDescriptionProperty: string, primaryEntityOrderProperty: string, requiredId: string }): RadPromiseLike<any>;
}

export class SoftDeleteEnabledListMixin
{
    public static classNamespace = NAMESPACE + "SoftDeleteEnabledListMixin";
    public static className = "SoftDeleteEnabledListMixin";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static _getSoftDeletedListItemAsync(control: ISoftDeleteEnabledListMixin, info: { listData: any[], primaryEntity: string, primaryEntityDescriptionProperty: string, primaryEntityOrderProperty: string, requiredId: string }): RadPromiseLike<any>
    {
        // Try and fetch record from soft-deleted records
        return (
            ServiceManager.getRequired(WebApiClientService)
                .createEntityGetRequest(
                    info.primaryEntity,
                    info.requiredId,
                    [
                        "id",
                        "deletedGuid",
                        info.primaryEntityDescriptionProperty
                    ],
                    { "RAD-Option-Include-Soft-Deleted": true }
                )
                .executeAsync()
                .then(softDeletedRecord =>
                {
                    info.listData.push(softDeletedRecord);
                    info.listData = info.listData.sort(item => ObjectHelper.propertyValueByPathGet<number>(item, info.primaryEntityOrderProperty) ?? 0);
                })
        );
    }
}